/**
 * Created by yechuzheng on 2017/8/2.
 */


import {Injectable} from '@angular/core';
import {isUndefined} from 'util';

declare var $: any;

@Injectable()
export class SettingsService {

    default_photo = '/assets/images/user-head.png';

    APPHOST = 'https://v1.wuyuyun.com';

    wechat = {
        AppID: 'wx7cf791b39d2b1118',
        AppSecret: 'REDACTED_APP_SECRET'
    };

    /**
     * 时间格式化 yyyy-MM-dd hh:mm:ss
     * @param {Date} date
     * @param fmt
     * @returns {any}
     */
    date_format(date: Date, fmt?: string): any {
        if (isUndefined(fmt)) {
            fmt = 'yyyy-MM-dd hh:mm:ss';
        }
        const o = {
            'M+': date.getMonth() + 1, // 月份
            'd+': date.getDate(), // 日
            'h+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
            'S': date.getMilliseconds() // 毫秒
        };

        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (const k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
            }
        }
        return fmt;
    }




    mqtt() {
        const mqtt = {
            host: 'ws://121.199.68.220:1884/mqtt',
            // host: 'ws://116.62.48.231:1884/mqtt',
            // host: 'wss://v1.wuyuyun.com/mqtt',
            clientId: 'WEB_' + Date.now() + '_' + Math.floor(Math.random() * 1000000)
        };
        return mqtt;
    }

    /**
     * 字符串时间转成时间（Date）格式
     * @param {string} date
     * @returns {Date}
     */
    parser_date(date: string): Date {
        const t = Date.parse(date);
        if (!isNaN(t)) {
            return new Date(Date.parse(date.replace(/-/g, '/')));
        } else {
            return new Date();
        }
    }

    str_date_format(date_time: string, fmt?: string) {
        if (isUndefined(fmt)) {
            fmt = 'yyyy-MM-dd';
        }
        return this.date_format(this.parser_date(date_time), fmt);
    }

    // 进入全屏
    requestFullScreen(element?: string) {
        const de: any = document.querySelector(element) || document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        }
    }

    // 退出全屏
    exitFullscreen() {
        const de: any = document;
        if (de.exitFullscreen) {
            de.exitFullscreen();
        } else if (de.mozCancelFullScreen) {
            de.mozCancelFullScreen();
        } else if (de.webkitCancelFullScreen) {
            de.webkitCancelFullScreen();
        }
    }

    // 检查全屏状态变化 Detecting fullscreen state change
    is_fullScreen() {
        const de: any = document;
        const fullscreenElement = de.fullscreenEnabled
            || de.mozFullscreenElement
            || de.webkitFullscreenElement;

        // const fullscreenEnabled = de.fullscreenEnabled
        // || de.mozFullscreenEnabled
        // || de.webkitFullscreenEnabled;
        if (fullscreenElement === null) {
            return false;
        } else {
            return true;
        }
    }

    // 音频音效播放
    play_audio(fileName?: string) {
        let src = `/assets/audio/anniu-katong1.mp3`;
        if (!isUndefined(fileName)) {
            src = `/assets/audio/${fileName}`;
        }
        const sound = new Audio(src);
        sound.controls = true;
        sound.play();
        sound.id = 'audio-sound';
        sound.hidden = true;
        sound.remove();
    }


    getDefaultHead(event) {
        event.target.src = this.default_photo;
    }


    split_map_lnglat(map_lnglat: string) {
        const lnglat = map_lnglat.split(',');

        return {
            lng: lnglat[0],
            lat: lnglat[1],
        };
    }

    getRandom(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    // downloadService(link): any {
    //     const options = new RequestOptions({ responseType: 3 });
    //     return this.http.get(link, options).map(res => res.json()).catch(this.handleError)
    // }
    //
    // onDownload(work) {
    //     const link = document.createElement('a');
    //     this._worksService.downloadService(work.path)
    //         .subscribe(
    //             data => {
    //                 this.loading.stop();
    //                 // Blob转化为链接
    //                 const blob = new Blob([data], {type: 'application/octet-stream'});
    //                 const objectUrl = window.URL.createObjectURL(blob);
    //                 link.setAttribute('href', objectUrl);
    //                 link.setAttribute('download', work.name + '.' + work.postfix);
    //                 link.style.visibility = 'hidden';
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);
    //                 URL.revokeObjectURL(objectUrl);
    //             },
    //             error => {
    //                 this.loading.stop();
    //                 this.createNotification('warning', '提示', '下载失败')
    //             });
    // }
}



